import { ModalModule } from 'ngx-bootstrap/modal';
import { SystemCommonModule } from 'src/app/system-common/system-common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClaimsRoutingModule } from './claims-routing.module';

import { ClaimsService } from './services/claims.service';
import { ClaimsBalanceSearchComponent } from './claims-balance-search/claims-balance-search.component';
import { ClaimsStatusSearchComponent } from './claims-status-search/claims-status-search.component';

@NgModule({
  declarations: [ClaimsStatusSearchComponent, ClaimsBalanceSearchComponent],
  imports: [CommonModule, SystemCommonModule, ClaimsRoutingModule, ModalModule.forRoot()],
  providers: [ClaimsService],
})
export class ClaimsModule {}
